//#region header */
/**************************************************************************************************
//
//  Description: Application store for managing the state of the application details.
//
//  Copyright:    © 2026 Idox Software Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//#region Version 1.0.0.0 changes
//    001   05.02.26 Sean Flook         GMSCM-12 Initial version.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */

import { create } from "zustand";
import { ApplicationErrorType } from "../models/applicationErrorType";
import { mountStoreDevtool } from "simple-zustand-devtools";
import { ApplicationNameDto } from "../dtos/applicationNamesDto";

interface ApplicationQuery {
  applicationItem?: string;
  newApplication?: boolean;
  applicationSelected?: string;
  applicationChanged?: boolean;
  applicationNames?: ApplicationNameDto[];
  disableSave?: boolean;
  validationErrors?: ApplicationErrorType[];
}

interface ApplicationQueryStore {
  applicationQuery: ApplicationQuery;
  setApplicationItem: (applicationItem: string | undefined) => void;
  setNewApplication: (newApplication: boolean) => void;
  setApplicationSelected: (applicationSelected: string | undefined) => void;
  setApplicationChanged: (applicationChanged: boolean) => void;
  setApplicationNames: (applicationNames: ApplicationNameDto[]) => void;
  setDisableSave: (disableSave: boolean) => void;
  setValidationErrors: (validationErrors: ApplicationErrorType[] | undefined) => void;
}

const useApplicationQueryStore = create<ApplicationQueryStore>((set) => ({
  applicationQuery: {},
  setApplicationItem: (applicationItem: string | undefined) =>
    set((state) => ({ applicationQuery: { ...state.applicationQuery, applicationItem } })),
  setNewApplication: (newApplication: boolean) =>
    set((state) => ({ applicationQuery: { ...state.applicationQuery, newApplication } })),
  setApplicationSelected: (applicationSelected: string | undefined) =>
    set((state) => ({ applicationQuery: { ...state.applicationQuery, applicationSelected } })),
  setApplicationChanged: (applicationChanged: boolean) =>
    set((state) => ({ applicationQuery: { ...state.applicationQuery, applicationChanged } })),
  setApplicationNames: (applicationNames: ApplicationNameDto[]) =>
    set((state) => ({ applicationQuery: { ...state.applicationQuery, applicationNames } })),
  setDisableSave: (disableSave: boolean) =>
    set((state) => ({ applicationQuery: { ...state.applicationQuery, disableSave } })),
  setValidationErrors: (validationErrors: ApplicationErrorType[] | undefined) =>
    set((state) => ({ applicationQuery: { ...state.applicationQuery, validationErrors } })),
}));

if (process.env.NODE_ENV === "development") {
  mountStoreDevtool("Application Store", useApplicationQueryStore);
}

export default useApplicationQueryStore;
